<template>
    <v-container>
        <!-- Add New User Component -->
        <AddNewUser @addedUser="handleUserAdded" :classsInfoList="classsInfoList" :users="users" />
        <!-- User List -->
        <v-card title="User List" flat>
            <v-row class="px-4 align-center justify-space-between">
                <v-col cols="2" class="mr-auto d-flex align-center">
                    <label class="mr-3" style="font-weight: 400">Show</label>
                    <v-select v-model="itemsPerPage" :items="[10, 20, 50]" variant="outlined" hide-details
                        class="w-25 v-custom-select" dense />
                </v-col>
                <v-col cols="3">
                    <v-text-field v-model="search" label="Search" prepend-inner-icon="mdi-magnify" variant="outlined"
                        hide-details class="w-100 v-custom-select" dense />
                </v-col>
            </v-row>
            <v-row class="pa-4">
                <v-btn color="primary" class="ml-3" dense @click="exportToCSV">
                    CSV
                </v-btn>
                <v-btn color="primary" class="ml-3" dense @click="exportToPDF">
                    PDF
                </v-btn>
                <v-btn color="primary" class="ml-3" dense @click="printTable">
                    Print
                </v-btn>
            </v-row>
            <!-- Skeleton Loader -->
            <v-data-table v-if="!loading" :headers="headers" :items="users" :search="search" item-value="id"
                class="elevation-1 mt-4 student-list-table" dense>
                <!-- Custom Templates for Table Columns -->
                <template #item.user_id="{ item }">
                    <span>{{ item.user.id }}</span>
                </template>
                <template #item.user="{ item }">
                    <v-row align="center" no-gutters>
                        <v-col class="d-flex align-center pa-2" :cols="3">
                            <v-img :src="getImage(item.user.image)"
                                " class="student-image mrr-10" alt="Student Image" />
                            <span>{{ item.user.first_name }} {{ item.user.last_name }}</span>
                        </v-col>
                    </v-row>
                </template>
                <template #item.class_info="{ item }">
                    <span v-if="
                        item.class_info &&
                        Array.isArray(item.class_info) &&
                        item.class_info.length > 0
                    ">
                        {{item.class_info.map((cls) => cls.name).join(", ")}}
                    </span>
                    <span v-else-if="item.class_info && !Array.isArray(item.class_info)">
                        {{ item.class_info.name }}
                    </span>
                    <span v-else> No Classes </span>
                </template>

                <template #item.actions="{ item }">
                    <div class="d-flex justify-space-between">
                        <v-btn icon @click="openEditUser(item)">
                            <v-icon>mdi-pencil</v-icon>
                        </v-btn>
                        <v-btn icon @click="deleteUser(item.user.id)">
                            <v-icon color="red">mdi-delete</v-icon>
                        </v-btn>
                    </div>
                </template>
            </v-data-table>

            <!-- Skeleton Loader -->
            <v-skeleton-loader v-else type="table" class="elevation-1 mt-4"></v-skeleton-loader>
        </v-card>
    </v-container>

    <!-- Edit User Dialog -->
    <v-dialog v-model="isEditDialogOpen" max-width="800">
        <UpdateUser v-if="selectedUser" :UserData="selectedUser" @updatedUser="handleUpdateUser"
            @close="isEditDialogOpen = false" />
    </v-dialog>

</template>
<script setup>
import { ref, onMounted, watch, computed } from "vue";
import { useRoute } from "vue-router";
import axios from "axios";
import Swal from "sweetalert2";
import { apiConfig } from "@/config/apiConfig";
import { getUser, classNames } from "@/services/apiServices";
import UpdateUser from "@/components/Apps/AddUser/updateUser.vue";
import AddNewUser from "@/components/Apps/AddUser/addNewUser.vue";
import banner1 from "@/assets/images/administrator.jpg";
// import { on } from "events";

// Refs
const error = ref("");
const users = ref([]);
const search = ref("");
const itemsPerPage = ref(10);
const isEditDialogOpen = ref(false);
const selectedUser = ref(null);
const loading = ref(true);
// const filteredClasses = ref([]);
const classsInfoList = ref([]);


// Headers for Data Table
const headers = [
    { align: "start", key: "user.id", sortable: true, title: "SN." },
    { key: "user.first_name", sortable: true, title: "First Name" },
    { key: "user.last_name", sortable: true, title: "Last Name" },
    { key: "user.username", sortable: true, title: "Username" },
    { key: "user.email", sortable: true, title: "Email" },
    { key: "verified_by", sortable: true, title: "Verified By" },
    { key: "class_info", sortable: false, title: "Class Info" },
    { key: "_password", sortable: false, title: "Password" },
    { key: "actions", sortable: false, title: "Actions" },
];

// const getImage = (item) => {
//   return item.image
//     ? `${apiConfig.imageUrl}/${item}`
//     : banner1;
// };
import { getCurrentInstance } from 'vue';
const { appContext } = getCurrentInstance();
const getImage = appContext.config.globalProperties.$getImage;

const fetchClasss = async () => {
    try {
        const data = await classNames();
        classsInfoList.value = data;
        // console.log("Class Info List:", classsInfoList);
    } catch (err) {
        error.value = err.response?.data?.message || "Failed to load classes";
        console.error("Error fetching class details:", err);
    }
};

const fetchUser = async () => {
    try {
        const res = await getUser();
        users.value = res;
    } catch (err) {
        console.error("Error fetching users:", err);
    } finally {
        loading.value = false; // Hide loader
    }
};






const handleUserAdded = (newUser) => {
    // console.log("New User Data:", newUser);

    const userToAdd = newUser.data || newUser;

    // Ensure `users` is initialized
    if (!Array.isArray(users.value)) {
        console.warn("users is not initialized. Initializing as an empty array.");
        users.value = [];
    }

    // Force Vue to detect the change
    users.value = [...users.value, userToAdd];

    // console.log("Updated users list:", users.value);
};
onMounted(async () => {
    await fetchUser();
    await fetchClasss();

});



// const handleUserAdded = (newUser) => {
//   console.log("New User Data:", newUser);

//   // Ensure the new user matches the structure of existing users
//   const formattedUser = {
//     user: {
//       first_name: newUser.first_name,
//       last_name: newUser.last_name,
//       contact: newUser.contact,
//       email: newUser.email,
//     },
//     verified_by: null, // Or set an appropriate value
//     class_info: newUser.class_info ? newUser.class_info.split(",") : [],
//     _password: newUser.password, // Optional
//   };

//   // Update the users list while maintaining Vue's reactivity
//   users.value = [...users.value, formattedUser];

//   console.log("Updated users list:", users.value);
// };

// Fetch Users


// Handle New User Added
// const handleUserAdded = (newUser) => {
//     const formattedNewUser = {
//         user: {
//             id: newUser.id,
//             first_name: newUser.first_name,
//             last_name: newUser.last_name,
//             username: newUser.username,
//             email: newUser.email,
//         },
//         verified_by: newUser.data.verified_by || null,
//         class_info: classOptions.filter((option) =>
//             newUser.class_info.includes(option.id)
//         ),
//         _password: newUser._password,
//     };
//     users.value.push(formattedNewUser);
// };

// Open Edit Dialog
const openEditUser = (item) => {
    selectedUser.value = { ...item };
    isEditDialogOpen.value = true;
};

const handleUpdateUser = (response) => {
    const updatedUser = response.data || response;
    if (!updatedUser || !updatedUser.user || !updatedUser.user.id) {
        console.error("Invalid updatedUser object:", updatedUser);
        return;
    }
    if (!Array.isArray(users.value)) {
        console.error("users is not an array:", users.value);
        return;
    }
    const index = users.value.findIndex(user => user.user.id === updatedUser.user.id);
    if (index !== -1) {
        users.value[index] = { ...users.value[index], ...updatedUser };
        users.value = [...users.value]; // Ensure reactivity
    } else {
        console.warn("User not found in the list!");
    }
    isEditDialogOpen.value = false;
};

// Delete User
const deleteUser = async (userId) => {
    try {
        const result = await Swal.fire({
            title: "Are you sure?",
            text: "Do you want to delete this student? This action cannot be undone.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, delete it!",
            cancelButtonText: "Cancel",
        });
        if (result.isConfirmed) {
            const accessToken = localStorage.getItem("accessToken");
            const response = await axios.delete(
                `${apiConfig.baseUrl}${apiConfig.veryfiedUser}`,
                {
                    headers: {
                        Accept: "application/json",
                        Authorization: `Bearer ${accessToken}`,
                        "USER-ID": userId,
                    },
                }
            );
            if (response.status === 200 || response.status === 204) {
                users.value = users.value.filter((user) => user.user.id !== userId);
                Swal.fire({
                    icon: "success",
                    title: "User deleted successfully",
                    toast: true,
                    position: "top-end",
                    showConfirmButton: false,
                    timer: 3000,
                    timerProgressBar: true,
                });
            } else {
                throw new Error("Failed to delete the student.");
            }
        }
    } catch (error) {
        console.error("Error deleting user:", error.message);
        Swal.fire({
            icon: "error",
            title: "Failed to delete student",
            text: error.message,
        });
    }
};
const exportToCSV = () => {
  const csv = Papa.unparse(
    employees.value.map((employee) => {
      // Filter out unwanted fields
      const { school, class_info, image, ...rest } = employee;

      // Extract only the 'name' field from nested objects
      rest.category = employee.category?.name || "N/A";
      rest.teaching_level = employee.teaching_level?.name || "N/A";

      return rest;
    })
  );

  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.setAttribute("download", "employees_list.csv");
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

const exportToPDF = () => {
  const doc = new jsPDF();
  const columns = [
    "EID",
    "Name",
    "Gender",
    "Blood Group",
    "Teaching Level",
    "Category",
    "Designation",
    "Contact",
  ];

  const rows = employees.value.map((employee) => [
    employee.employee_id,
    employee.name,
    employee.gender,
    employee.blood_group,
    employee.teaching_level?.name || "N/A",
    employee.category?.name || "N/A",
    employee.designation,
    employee.contact,
  ]);

  autoTable(doc, {
    head: [columns],
    body: rows,
    startY: 20, // Start drawing the table from Y=20 (below the title)
    margin: { top: 30 }, // Add a top margin if necessary
    styles: {
      fontSize: 10,
      cellPadding: 3,
    },
    headStyles: {
      fillColor: [22, 160, 133],
      textColor: [255, 255, 255],
      fontStyle: "bold",
    },
    alternateRowStyles: {
      fillColor: [240, 240, 240],
    },
  });

  doc.save("employees_list.pdf");
};

const printTable = () => {
  if (!employees.value.length) {
    console.error("No data to print");
    return;
  }

  let tableHtml = `<table border="1" width="100%">
    <thead>
      <tr>`;

  // Exclude the 'actions' column from the header
  headers.value.forEach((header) => {
    if (header.key !== "actions") {
      tableHtml += `<th>${header.title}</th>`;
    }
  });

  tableHtml += `</tr>
    </thead>
    <tbody>`;

  employees.value.forEach((employee) => {
    tableHtml += `<tr>`;
    headers.value.forEach((header) => {
      if (header.key !== "actions") {
        let value = employee[header.key];

        if (typeof value === "object" && value !== null) {
          if (header.key === "teaching_level") {
            value = value.name || "N/A"; 
          } else if (header.key === "category") {
            value = value.name || "N/A"; 
          } else {
            value = "N/A"; 
          }
        }

        tableHtml += `<td>${value || ""}</td>`;
      }
    });
    tableHtml += `</tr>`;
  });

  tableHtml += `</tbody>
  </table>`;

  const w = window.open("", "", "width=800,height=600");

  w.document.write(`
    <html>
      <head>
        <title>Employee List</title>
        <style>
          body { font-family: Arial, sans-serif; margin: 20px; color: #333; background-color: #fff; }
          table { width: 100%; border-collapse: collapse; margin-top: 20px; }
          th, td { padding: 12px 15px; text-align: left; border-bottom: 1px solid #ddd; }
          th { background-color: #f4f4f4; font-weight: bold; }
          tr:nth-child(even) { background-color: #f9f9f9; }
          @media print {
            body { margin: 0; padding: 0; }
            table { width: 100%; }
            th, td { font-size: 12px; padding: 8px; }
          }
        </style>
      </head>
      <body>
        
        ${tableHtml}
      </body>
    </html>
  `);

  w.document.close();

  setTimeout(() => {
    w.focus();
    w.print();
    w.close();
  }, 500);
};

</script>
